// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1JNr1","search":"Settings_search__2mTkh","filter":"Settings_filter__3V-9M"};